<template>
    <section id="print">
        <div class="rowVar">
            <ul>
                <template v-for="(variety, index) in items">
                    <li v-for="q in +variety.quantity" class="variety varietyRow">
                        <div class="varietyContainer">
                            <div class="barcodeContainer">
                                <textarea  
                                    rows="1"  
                                    type="text"  
                                    v-model="variety.product_title"  
                                    class="varietyPrice"  
                                    @input="adjustHeight"  
                                ></textarea> 
                                <div class="row" v-if="variety.variety_attributes && variety.variety_attributes.length">
                                    <div v-for="item in variety.variety_attributes" class="itemRow" :key="item.id">
                                        <span class="varName" v-if="variety.variety_color_name && variety.variety_color_name">
                                            {{ item.pivot.value + ' | ' + variety.variety_color_name}}
                                        </span>
                                        <span class="varName" v-else>
                                            {{ item.pivot.value}}
                                        </span>
                                    </div>
                                </div>
                                <div class="row" v-else>
                                    <div class="itemRow">
                                        <span class="varName">
                                            {{ variety.variety_color_name }}
                                        </span>
                                    </div>
                                </div>
                                
                                  <barcode
                                        class="varietyBarcode"
                                        fontSize="40"
                                        width="7"
                                        marginBottom="0"
                                        marginTop="0"
                                        elementTag="img"

                                        :displayValue="true"
                                        height="50"
                                       :value="variety.variety_barcode"
                                    >
                                    </barcode>

                                <span class="priceName" v-if="variety.price > variety.variety_price">
                                    <del>{{ formatPrice(variety.price) }} تومان  </del>
                                </span>
                                <span class="priceName">
                                    {{ formatPrice(variety.variety_price) }} تومان  
                                </span>
                            </div>
                        </div>
                    </li>
                </template>
            </ul>
        </div>
        <button id="printBtn" @click="print">پرینت</button>
    </section>
</template>

<script>
import printVarietiesImpl from "@@/core/pages/Havale/BarcodePrint/BarcodePrintLmpl";
export default {
    extends: printVarietiesImpl,
};
</script>

<style src="@@/core/pages/printVarieties/printVarietiesStyle.css"></style>
